export default class Character extends Phaser.Group {
  constructor(game, name, offsets) {
    super(game);

    this.name = name;
    this.offsets = offsets;
    this.currentAnim = '';
    this.onActionEnd = new Phaser.Signal();
    this.onNodEnd = new Phaser.Signal();

    //
    this.anims1 = this.game.make.sprite(0, 0, 'foodgame_' + name + '1');
    this.anims1.anchor.set(0.5, 1);
    this.anims2 = this.game.make.sprite(0, 0, 'foodgame_' + name + '2'); // eating anim
    this.anims2.anchor.set(0.5, 1);
    this.arm = this.game.make.sprite(0, 0, 'foodgame_' + name + '1');
    this.arm.anchor.set(0.5, 1);
    this.hand = this.game.make.sprite(0, 0, 'foodgame_' + name + '1');
    this.hand.anchor.set(0.5, 1);

    this.addChild(this.anims1);
    this.addChild(this.anims2);

    let anim;
    let frames;

    // idle
    this.anims1.animations.add('idle', ['lean/frame_0001.png'], 24, false);

    // lean front
    frames = Phaser.Animation.generateFrameNames('lean/frame_', 1, 4, '.png', 4);
    anim = this.anims1.animations.add('lean_front', frames, 24, false, false);

    // lean back
    frames = Phaser.Animation.generateFrameNames('lean/frame_', 4, 7, '.png', 4);
    anim = this.anims1.animations.add('lean_back', frames, 24, false, false);
    anim.onComplete.add(this.handleLeanBackEnd, this);

    // nod
    frames = Phaser.Animation.generateFrameNames('nod/frame_', 1, 9, '.png', 4);
    anim = this.anims1.animations.add('nod', frames, 24, false, false);
    anim.onComplete.add(this.handleNodEnd, this);

    // duck
    this.anims1.animations.add('duck', ['duck/frame_0001.png'], 24, false);

    // sad
    this.anims1.animations.add('sad', ['sad/frame_0001.png'], 24, false);

    // eat - set 2
    frames = Phaser.Animation.generateFrameNames('eat/frame_', 1, 32, '.png', 4);
    anim = this.anims2.animations.add('eat', frames, 24, false, false);

    // arm
    this.arm.animations.add('idle', ['arm/frame_0001.png'], 24, false);
    frames = Phaser.Animation.generateFrameNames('arm/frame_', 1, 9, '.png', 4);
    anim = this.arm.animations.add('nod', frames, 24, false, false);

    // hand
    this.hand.animations.add('idle', ['hand/frame_0001.png'], 24, false);
    frames = Phaser.Animation.generateFrameNames('hand/frame_', 1, 9, '.png', 4);
    anim = this.hand.animations.add('nod', frames, 24, false, false);

    //
    this.setAnim('idle');
  }

  setAnim(animName) {
    if (this.currentAnim != animName) {
      this.currentAnim = animName;

      // reset anims
      this.anims1.animations.stop();
      this.anims2.animations.stop();
      this.anims1.visible = false;
      this.anims2.visible = false;

      // play anim
      if (animName == 'eat') {
        this.anims2.visible = true;
        this.anims2.play(animName);
        this.anims2.x = this.offsets[animName].x;
        this.anims2.y = this.offsets[animName].y;
      } else {
        this.anims1.visible = true;
        this.anims1.play(animName);
        this.anims1.x = this.offsets[animName].x;
        this.anims1.y = this.offsets[animName].y;
      }

      // hand and arm anims
      if (animName == 'nod') {
        this.hand.play(animName);
        this.arm.play(animName);
      } else {
        this.hand.play('idle');
        this.arm.play('idle');
      }
    }
  }

  stop() {
    if (!this.anims2.visible) {
      this.anims1.animations.paused = true;
      this.anims2.animations.paused = true;
    }
  }

  leanFront() {
    this.setAnim('lean_front');
  }

  leanBack() {
    this.setAnim('lean_back');
  }

  handleLeanBackEnd() {
    this.onActionEnd.dispatch();
  }

  nod() {
    this.setAnim('nod');
    this.game.sounds.playSpriteSFX('fork', { spriteID: 'game_audiosprite', delay: 400 });
  }

  handleNodEnd() {
    this.setAnim('idle');
    this.onNodEnd.dispatch();
  }

  eat(playAudio) {
    this.setAnim('eat');
    this.game.time.events.add(2000, this.handleEatEnd, this);

    if (playAudio) {
      this.game.sounds.playSpriteSFX('eating', { spriteID: 'game_audiosprite' });
    }
  }

  handleEatEnd() {
    this.onActionEnd.dispatch();
  }

  duck() {
    this.setAnim('duck');
    let tween = this.game.add
      .tween(this.anims1)
      .to({ y: [this.anims1.y + 190, this.anims1.y] }, 1000, Phaser.Easing.Quadratic.InOut, true);
    tween.onComplete.add(this.handleDuckAnimEnd, this);
  }

  handleDuckAnimEnd() {
    this.setAnim('idle');
    this.game.time.events.add(500, this.handleDuckEnd, this);
  }

  handleDuckEnd() {
    this.onActionEnd.dispatch();
  }

  sad() {
    this.setAnim('sad');
    this.game.time.events.add(1000, this.handleSadEnd, this);
  }

  handleSadEnd() {
    this.onActionEnd.dispatch();
  }
}



// WEBPACK FOOTER //
// ./js/app/games/food/Character.js